import axios from "axios";
import { Config } from "../../data/config";
export const SET_SERVICE = "SERVICE | SET_SERVICE";
export const RESET_SERVICE = "SERVICE | RESET_SERVICE";

export function fetchServices(bid) {
  return function(dispatch) {
    axios
      .get(`${Config.frontApiUrl}/onboarding/services/${bid}`)
      .then(response => {
        dispatch(
          setServices({
            internet: response.data.internet.sort((a, b) => a.price - b.price),
            phone: response.data.phone.sort((a, b) => a.price - b.price),
            wifiRouter: response.data.hardware
            // .filter(
            //   hardware => hardware.is_router === 1
            // )
            .sort((a, b) => a.price - b.price),
            shipping: response.data.general.find((item) => item.code === 'SHIP')
          })
        );
      });
  };
}

export function setServices(data) {
  return { type: SET_SERVICE, payload: data };
}

export function resetServices() {
  return { type: RESET_SERVICE };
}




// WEBPACK FOOTER //
// ./src/store/actions/service.js